import { API_URL, API_URL_v2, API_URL_v3 } from '../env';

export const mixFnum = (number: number) => {
  return new Intl.NumberFormat('vi-VN', { maximumSignificantDigits: 3 }).format(number);
}

export const mixGetV1 = async (url: string, params = {} as any) => {
  Object.keys(params).map((isKey, index) => {
    if (params[isKey] || params[isKey] === 0) {
      if (Array.isArray(params[isKey])) {
        params[isKey].map((val: any) => {
          url = `${url}${index === 0 ? '?' : '&'}${isKey}=${val}`
          return true
        })
      } else {
        url = `${url}${index === 0 ? '?' : '&'}${isKey}=${params[isKey]}`
      }
    }
    return null
  })
  const response = await fetch(`${API_URL}${url}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    throw new Error('Network response was not ok');
  }
  const temp = await response.json()
  return temp
}

export const mixGetV2 = async (url: string, paramsx = {} as any, domainApi?: string) => {
  const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MSwidGltZSI6MTcyMzQ0ODM5MCwiaXAiOiIxMTUuNzguMTQuMjQ0In0.x_OQ9U3-_B3oIlxuAIi0Tq_Z0yFEAdC-DhfUtgfp2Yo'
  const params = {
    ...paramsx,
    // vehicle_brand: localStorage.getItem('vehicle_brand') || ''
  }
  Object.keys(params).map((isKey, index) => {
    if (params[isKey] || params[isKey] === 0) {
      if (Array.isArray(params[isKey])) {
        params[isKey].map((val: any) => {
          url = `${url}${index === 0 && url.includes('?') === false ? '?' : '&'}${isKey}=${val}`
          return true
        })
      } else {
        url = `${url}${index === 0 && url.includes('?') === false ? '?' : '&'}${isKey}=${params[isKey]}`
      }
    }
    return null
  })
  const response = await fetch(`${domainApi ? domainApi : API_URL_v2}${url}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    if (response.status === 401) {
    }
  }
  const temp = await response.json()
  return temp

}


export const mixGetV3 = async (url: string, paramsx = {} as any, options: { skipVehicleBrand?: boolean } = {}) => {
  const token = ''
  const params = {
    ...paramsx,
    ...(options.skipVehicleBrand ? {} : { vehicle_brand: localStorage.getItem('vehicle_brand') || '' })
  }
  Object.keys(params).map((isKey, index) => {
    if (params[isKey] || params[isKey] === 0) {
      if (Array.isArray(params[isKey])) {
        params[isKey].map((val: any) => {
          url = `${url}${url.includes('?') ? '&' : '?'}${isKey}=${val}`
          return true
        })
      } else {
        url = `${url}${url.includes('?') ? '&' : '?'}${isKey}=${params[isKey]}`
      }
    }
    return null
  })
  const response = await fetch(`${API_URL_v3}${url}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    if (response.status === 401) {
    }
  }
  const temp = await response.json()
  return temp

}

export const mixGetApiV4 = async (url: string, params = {} as any) => {
  const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MSwidGltZSI6MTcyMzQ0ODM5MCwiaXAiOiIxMTUuNzguMTQuMjQ0In0.x_OQ9U3-_B3oIlxuAIi0Tq_Z0yFEAdC-DhfUtgfp2Yo'
  Object.keys(params).map((isKey, index) => {
    if (params[isKey] || params[isKey] === 0) {
      if (Array.isArray(params[isKey])) {
        params[isKey].map((val: any) => {
          url = `${url}${index === 0 ? '?' : '&'}${isKey}=${val}`
          return true
        })
      } else {
        url = `${url}${index === 0 ? '?' : '&'}${isKey}=${params[isKey]}`
      }
    }
    return null
  })
  const response = await fetch(`${url}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    if (response.status === 401) {
    }
  }
  const temp = await response.json()
  return temp

}

export const mixPostV1 = async (url: string, param: {}) => {
  const response = await fetch(`${API_URL}${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify(param),
  })
  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
  }
  const temp = await response.json()
  return temp
}

export const mixPostV2 = async (url: string, paramx: any, options: { skipVehicleBrand?: boolean } = {}) => {
  const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MSwidGltZSI6MTcyMzQ0ODM5MCwiaXAiOiIxMTUuNzguMTQuMjQ0In0.x_OQ9U3-_B3oIlxuAIi0Tq_Z0yFEAdC-DhfUtgfp2Yo'
  const formData = new FormData()
  const param = {
    ...paramx,
    ...(options.skipVehicleBrand ? {} : { vehicle_brand: localStorage.getItem('vehicle_brand') || '' })
  }
  Object.keys(param).map((keyParam: any) => {
    formData.append(keyParam, param[keyParam])
    return true
  })

  const response = await fetch(`${API_URL_v2}${url}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  })
  if (!response.ok) {
    if (response.status === 401) {

    }
  }
  const temp = await response.json()
  return temp
}

export const mixDelV1 = async (url: string, param: {}) => {
  const response = await fetch(`${API_URL}${url}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify(param),
  })
  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
  }
  const temp = await response.json()
  return temp
}

export const mixTreeIds = (arr = [] as any) => {
  const res = [] as any
  arr.map((item: any) => {
    if (typeof item === 'number' && !isNaN(item)) {
      res.push(item)
    } else {
      const temp = item.split('-')
      res.push(parseInt(temp[1]))
    }
    return true
  })
  return res
}

export const mixGender = (valx: any) => {
  const list = [
    {
      value: 1,
      title: 'Nam',
    },
    {
      value: 0,
      title: 'Nữ',
    },
    {
      value: 2,
      title: 'Không xác định',
    }
  ]
  const obs = {} as any
  list.map(val => {
    obs[`s${val.value}`] = val
    return true
  })
  if (valx || valx === 0) {
    return obs[`s${valx}`] || null
  }
  return list
}

export const uploadFileImportReview = async (files: any, admin_id?: any) => {
  const formData = new FormData();
  files.forEach((file: any) => {
    formData.append('files', file);
  });
  if (admin_id !== undefined && admin_id !== null && admin_id !== '') {
    formData.append('admin_id', String(admin_id));
  }

  const response = await fetch(`${API_URL_v3}/import/file_import_review/`, {
    method: 'POST',
    headers: {
      'accept': 'application/json'
    },
    body: formData
  });

  if (!response.ok) {
    const error = new Error('Upload failed: ' + response.statusText) as any;
    error.status = response.status;
    try { error.body = await response.json(); } catch (e) { }
    throw error;
  }

  return response.json();
}

export const uploadMultipleFiles = async (files: any, admin_id?: any, task_id?: any) => {
  const formData = new FormData();
  files.forEach((file: any) => {
    formData.append('files', file);
  });
  if (admin_id !== undefined && admin_id !== null && admin_id !== '') {
    formData.append('admin_id', String(admin_id));
  }
  if (task_id) {
    formData.append('task_id', String(task_id));
  }

  const response = await fetch(`${API_URL_v3}/import/file_import_process/`, {
    method: 'POST',
    headers: {
      'accept': 'application/json'
    },
    body: formData
  });

  if (!response.ok) {
    const error = new Error('Upload failed: ' + response.statusText) as any;
    error.status = response.status;
    try { error.body = await response.json(); } catch (e) { }
    throw error;
  }

  return response.json();
}

export const importFileStep4 = async (files: any, json_data: any) => {
  const formData = new FormData();
  files.forEach((file: any) => {
    formData.append('files', file); // Nếu API yêu cầu nhiều file cùng key 'files'
  });
  formData.append('json_data', JSON.stringify(json_data));

  const response = await fetch(`${API_URL_v3}/import/simple-queue/?normalize_phone=true&normalize_dates=true&normalize_boolean=true&normalize_strings=true`, {
    method: 'POST',
    headers: {
      'accept': 'application/json'
      // KHÔNG set Content-Type, fetch sẽ tự động set cho FormData
    },
    body: formData
  });

  if (!response.ok) {
    const error = new Error('Upload failed: ' + response.statusText) as any;
    error.status = response.status;
    try { error.body = await response.json(); } catch (e) { }
    throw error;
  }

  return response.json();
}

export const mixPostV3 = async (url: string, paramx: any, options: { skipVehicleBrand?: boolean } = {}) => {
  const param = {
    ...paramx,
    ...(options.skipVehicleBrand ? {} : { vehicle_brand: localStorage.getItem('vehicle_brand') || '' })
  }
  const response = await fetch(`${API_URL_v3}${url}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(param)
  });

  if (!response.ok) {
    const error = new Error('Upload failed: ' + response.statusText) as any;
    error.status = response.status;
    try { error.body = await response.json(); } catch (e) { }
    throw error;
  }

  return response.json();
}

export const mixGetTime = (dateString: any) => {
  const [day, month, year] = dateString.split(/[-/]/)
  const dateObject = new Date(year, month - 1, day)
  return dateObject.getTime()
}

export function mixGetTime_V2(date: string | null | undefined): number {
  if (!date || isNaN(new Date(date).getTime())) {
    return 0; // Trả về 0 nếu ngày không hợp lệ
  }
  return new Date(date).getTime();
}

export const mixDate = (date = null, option = {} as any) => {
  let str = ''
  try {
    let d = new Date()
    if (date) {
      d = new Date(date)
    }
    const year = d.getFullYear()
    const month = (d.getMonth() + 1).toString().padStart(2, '0')
    const day = d.getDate().toString().padStart(2, '0')
    if (option.hour) {
      const hours = d.getHours().toString().padStart(2, '0')
      const minutes = d.getMinutes().toString().padStart(2, '0')

      str = `${day}${option.bass || '/'}${month}${option.bass || '/'}${year} ${hours}:${minutes}`
      return str
    }

    if (option.ishour) {
      let hour = d.getHours() as any
      let minute = d.getMinutes() as any
      if (hour < 10) {
        hour = `0${hour}`
      }
      if (minute < 10) {
        minute = `0${minute}`
      }
      str = `${hour}:${minute}`
      return str
    }

    str = `${day}${option.bass || '/'}${month}${option.bass || '/'}${year}`
  } catch (error) {
    str = `2${option.bass || '/'}2${option.bass || '/'}2022`
  }
  return str
}

export const datetimeFormat = (date: string) => {
  let result = ''

  try {
    const newDate = new Date(date)
    const _time = newDate.toLocaleTimeString("en-GB")
    const _date = newDate.toLocaleDateString("en-GB")
    result = `${_time} ${_date}`
  } catch (error) {
    result = ''
  }

  return result
}
export const removeVietnameseAccents = (str: string) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
}
export const excelDateToString = (serial: number): string => {
  // Số serial hợp lệ của Excel thường lớn hơn 25569 (tương ứng 1/1/1970)
  if (typeof serial !== "number" || serial < 25569 || serial > 60000) return serial as unknown as string;
  const utc_days = Math.floor(serial - 25569);
  const utc_value = utc_days * 86400;
  const date_info = new Date(utc_value * 1000);
  // Định dạng dd/mm/yyyy
  return date_info.getDate().toString().padStart(2, '0') + '/' +
    (date_info.getMonth() + 1).toString().padStart(2, '0') + '/' +
    date_info.getFullYear();
};

export const calculateAge = (dateString: string): any | null => {
  if (!dateString) return '';
  const [day, monthx, year] = dateString.split('/');
  const birthYear = parseInt(year, 10);
  if (isNaN(birthYear)) return '';
  const currentYear = new Date().getFullYear();
  return currentYear - birthYear;
};
export const formatCurrency = (amount: number, currency: string = 'VND', locale: string = 'vi-VN') => {
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
};

export const formatNumber = (value: number) => {
  const res = new Intl.NumberFormat('vi-VN').format(value);
  if (res === 'NaN') return value;
  return res;
}

export const mixConvertSize = (value: number) => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let index = 0;
  let size = value;
  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index++;
  }
  return `${size.toFixed(2)} ${units[index]}`;
}

export const mixSynStatus = (status = null as any) => {
  const statusList = [
    { value: 0, title: 'Chưa đồng bộ', color: 'error' },
    { value: 1, title: 'Đã đồng bộ', color: 'success' },
    { value: 2, title: 'Đang đồng bộ', color: 'warning' },
  ];
  const statusMap = {} as any;
  statusList.forEach((item) => {
    statusMap[item.value] = item;
  });

  if(status || status === 0) {
    return statusMap[status] || { value: status, title: 'Không xác định', color: 'black' };
  } else {
    return statusList
  }
}

export const mixDataStatus = (status = null as any) => {
  const statusList = [
    { value: 0, title: 'Mới', color: 'processing' },
    { value: 1, title: 'Cập nhật', color: 'warning' },
  ];
  const statusMap = {} as any;
  statusList.forEach((item) => {
    statusMap[item.value] = item;
  });

  if(status || status === 0) {
    return statusMap[status] || { value: status, title: 'Không xác định', color: 'black' };
  } else {
    return statusList
  }
}
export const mixHisStatus = (status = null as any) => {
  const statusList = [
    { value: 1, title: 'Thành công', color: 'success' },
    { value: 2, title: 'Thất bại', color: 'error' },
  ];
  const statusMap = {} as any;
  statusList.forEach((item) => {
    statusMap[item.value] = item;
  });

  if(status || status === 0) {
    return statusMap[status] || { value: status, title: 'Không xác định', color: 'black' };
  } else {
    return statusList
  }
}

export const mixGetSourceColumnWarehouses = async () => {
    const res = await mixGetV2('/api/v1/be/source_column_warehouses', {
      'sort[]': 'id,asc',
      page: 1,
      limit: 100000,
      is_active: 1,
    })
    if (res.status) {
      const groupCats = [] as any
      res.data.items.map((val: any) => {
        val.category_column_source_column.map((item: any) => {
          const findData = groupCats.find((x: any) => x.key === item.key)
          if (!findData) {
            groupCats.push({
              ...item,
              list: []
            })
          }
        })
        return true
      })
      const obData = {} as any
      groupCats.map((item: any, index: number) => {
        const list = res.data.items
          .filter((val: any) => val.category_column_source_column.some((cat: any) => cat.key === item.key))
          .map((val: any) => {
            const catItem = val.category_column_source_column.find((cat: any) => cat.key === item.key)
            return {
              ...val,
              field: val.code,
              headerName: catItem?.label || val.name,
              hide: catItem?.is_show !== 1,
              position: catItem?.position ?? 0,
              catkey: val.category_column_source_column.map((cat: any) => cat.key)
            }
          })
          .sort((a: any, b: any) => (a.position ?? 0) - (b.position ?? 0))
        obData[item.key] = {
          ...item,
          pos: index,
          list
        }
        return true
      })
      return obData
    }
  }
